// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output } from '@angular/core';
import { ProjectNavigationModel, ProjectNavigationResult } from '../project-navigation.model';
import { ProjectNavigationService } from '../service/project-navigation.service';
import { UserSettings } from '@user/model/user-settings';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { ProjectGroupUtils } from '@project/components/project/util/project-group-utils';
import { UserModel } from '@user/model/user.model';

@Component({
  standalone: false,
  templateUrl: './import-cae.component.html',
  selector: 'app-import-cae'
})
export class ImportCaeComponent implements OnInit, OnDestroy {
  @Output() public finish = new EventEmitter<ProjectNavigationResult<ProjectGroupVO>>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;

  constructor(
    private userSettings: UserSettings,
    private userModel: UserModel,
    private projectNavigationService: ProjectNavigationService
  ) {}

  public ngOnInit() {
    this.model = new ProjectNavigationModel();
    this.model.canNavigateIntoProjectGroups = false;
    this.model.currentModel = {
      importType: ProjectGroupVO.CAE_IMPORT_TYPE,
      lastSelectedGroupId: this.userSettings.lastSelectedProjectGroupId,
      visibleSharedProjects: true
    };

    this.projectNavigationService.openPreselectedProjectGroup(this.model);
  }

  public updateSubmitEnabled(): void {
    this.submitEnabled = this.isActionButtonEnabledImportMode();
  }

  private isActionButtonEnabledImportMode(): boolean {
    const currentProjectGroup: ProjectGroupVO = this.model.currentProjectFolder;
    if (!currentProjectGroup) {
      return false;
    }
    return !this.isInsideCaeProjectGroup(currentProjectGroup);
  }

  private isInsideCaeProjectGroup(selectedItem
                                    : ProjectHeadVO | ProjectGroupVO): boolean {
    let projectGroup: ProjectGroupVO;
    if (selectedItem instanceof ProjectHeadVO) {
      projectGroup = selectedItem.projectGroup;
    } else {
      projectGroup = selectedItem as ProjectGroupVO;
    }
    if (!projectGroup) {
      return true;
    }
    while (projectGroup) {
      if (ProjectGroupVO.CAE_IMPORT_TYPE === projectGroup.importType) {
        return true;
      }
      projectGroup = projectGroup.parentGroup;
    }
    return false;
  }

  public ngOnDestroy() {}

  public cancel() {
    this.finish.emit({success: true, result: undefined});
  }

  public importCae() {
    let targetProjectGroup: ProjectGroupVO;
    let selectedItem: boolean = false;
    if (this.model.currentSelectedItem instanceof ProjectGroupVO && !ProjectGroupUtils.isConfigurationGroup(this.model.currentSelectedItem)) {
      targetProjectGroup = this.model.currentSelectedItem;
      selectedItem = true;
    } else {
      targetProjectGroup = this.model.currentProjectFolder;
    }
    if (targetProjectGroup) {
      let selectedGroupId: number = null;
      if (targetProjectGroup.groupType !== -1 && (!this.model.isInRoot() || selectedItem)) {
        selectedGroupId = targetProjectGroup.id;
      } else if (this.userModel.user.id !== targetProjectGroup.groupOwner.userId) {
        return;
      }
      this.userSettings.setUserSettingValue("lastSelectedProjectGroupId", selectedGroupId);
      this.userSettings.saveUserSettings();
      this.finish.emit({success: true, result: targetProjectGroup});
    }
  }
}
